import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateIncidentInput, IncidentCreatedOutput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `POST /v1/incidents` — livré en v1.9.0. `courseId` accepte l'id de course
 * interne ou la référence externe SNCF ; sans course correspondante le back
 * répond 422 `COURSE_NOT_FOUND`, que la modale affiche sur le champ.
 */
export const useCreateIncident = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateIncidentInput) =>
      getExtranetApi().post<CreateIncidentInput, IncidentCreatedOutput>('/v1/incidents', input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: extranetQueryKeys.incidents.root() });
      queryClient.invalidateQueries({ queryKey: extranetQueryKeys.dashboard.root() });
    },
  });
};
